/* eslint-disable */
// Replaces: /\B(?=(\d{3})+(?!\d))/g
function formatNumberSecure(str) {
  if (!/^\d+(\.\d+)?$/.test(str)) return str;
  const parts = str.split('.');
  const integerPart = parts[0];
  const decimalPart = parts[1];
  let result = '';
  for (let i = integerPart.length - 1, count = 0; i >= 0; i--, count++) {
    if (count === 3) {
      result = ',' + result;
      count = 0;
    }
    result = integerPart[i] + result;
  }
  return decimalPart !== undefined ? result + '.' + decimalPart : result;
}

// Replaces: /(?=.*[a-z])/
function hasLowercase(str) {
  for (let i = 0; i < str.length; i++) {
    if (str[i] >= 'a' && str[i] <= 'z') return true;
  }
  return false;
}

// Replaces: /(?=.*[A-Z])/
function hasUppercase(str) {
  for (let i = 0; i < str.length; i++) {
    if (str[i] >= 'A' && str[i] <= 'Z') return true;
  }
  return false;
}

// Replaces: /(?=.*\d)/
function hasDigit(str) {
  for (let i = 0; i < str.length; i++) {
    if (str[i] >= '0' && str[i] <= '9') return true;
  }
  return false;
}

// Replaces: /(?=.*[!@#$%^&*()+=.,_-])/
function hasSpecialChar(str) {
  const specialChars = '!@#$%^&*()+=.,_-';
  for (let i = 0; i < str.length; i++) {
    if (specialChars.includes(str[i])) return true;
  }
  return false;
}

// Replaces: /^[^\s@]+@[^\s@]+\.[^\s@]+$/ and /\S+@\S+\.\S+/
function validateEmail(email) {
  for (let i = 0; i < email.length; i++) {
    if (email[i] === ' ' || email[i] === '\t' || email[i] === '\n' || email[i] === '\r') {
      return false;
    }
  }
  if (email.length > 254) return false;
  const atIndex = email.indexOf('@');
  const lastAtIndex = email.lastIndexOf('@');
  if (atIndex === -1 || atIndex !== lastAtIndex) return false;
  if (atIndex === 0 || atIndex === email.length - 1) return false;
  const localPart = email.substring(0, atIndex);
  const domainPart = email.substring(atIndex + 1);
  if (localPart.length === 0 || localPart.length > 64) return false;
  const lastDotIndex = domainPart.lastIndexOf('.');
  if (lastDotIndex === -1) return false;
  if (lastDotIndex === 0 || lastDotIndex === domainPart.length - 1) return false;
  const domainName = domainPart.substring(0, lastDotIndex);
  const tld = domainPart.substring(lastDotIndex + 1);
  if (domainName.length === 0 || tld.length === 0) return false;
  return true;
}

export default {
  formatNumberSecure,
  hasLowercase,
  hasUppercase,
  hasDigit,
  hasSpecialChar,
  validateEmail
};
